export default "__VITE_ASSET__BaMmRYi9__"